import Vue from 'vue';
import vuetify from '../../plugins/vuetify';
import TermsOfService from './TermsOfService.vue';
import ko from 'knockout';
import template from 'raw-loader!./termsOfServiceView.html';

class TermsOfServiceView {
  constructor(params) {
    this.route = ko.unwrap(params.route);
  }

  koDescendantsComplete() {
    const route = this.route;
      new Vue({
        el: '#termsOfService',
        vuetify,
        render: h => h(TermsOfService, {
          props: { route }
        })
      });
  }
}

ko.components.register('terms-of-service-view', { template: template, viewModel: TermsOfServiceView });
